import { ICON_COMPONENT_SUFFIX, ICON_DEFAULT_PROPS } from "./armor-system-3674ALTA.js";
import { __spreadValues } from "./armor-system-JQVN7XCJ.js";

// src/util/getChildrenWithIconProps/getChildrenWithIconProps.ts
import { Children, cloneElement, isValidElement } from "react";
function getChildrenWithIconProps(baseChildren, getIconProps) {
  var children = Children.toArray(baseChildren);
  var childrenCount = children.length;
  return children.map(function (child, index) {
    var _a, _b, _c;
    var isValidChild = isValidElement(child);
    var isIcon = (_c = (_b = (_a = child == null ? void 0 : child.type) == null ? void 0 : _a.displayName) == null ? void 0 : _b.endsWith) == null ? void 0 : _c.call(_b, ICON_COMPONENT_SUFFIX);
    if (!isValidChild || !isIcon) {
      return child;
    }
    return cloneElement(child, __spreadValues(__spreadValues(__spreadValues({}, (child == null ? void 0 : child.props) || {}), ICON_DEFAULT_PROPS), getIconProps(childrenCount, index)));
  });
}
var getChildrenWithIconProps_default = getChildrenWithIconProps;
export { getChildrenWithIconProps_default };